import axios from 'axios';

const API_URL = 'https://expensetracker-yj7e.onrender.com/api/categories';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
};

const CategoryService = {
  getCategories: async () => {
    try {
      const response = await axios.get(API_URL, getAuthHeaders());
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  addCategory: async (category) => {
    try {
      const response = await axios.post(API_URL, { category }, getAuthHeaders());
      return response.data;
    } catch (error) {
      console.error('Error adding category:', error);
      throw error;
    }
  },
};

export default CategoryService;
